/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
// pages
import PurchaseSummaries from "./PurchaseSummaries";
import Purchase from "./Purchase";
// apis
import { getCardPurchaseSummaries, getCardPurchaseSummariesExcel } from "../../../../apis/finances/cards";
// components
import Filters from "../../../../components/Filters";
import { ControlTable } from "../../../../components/Table";
// utils
import { getDay } from "../../../../utils/date";
import { getParams } from "../../../../utils/params";
import { classnames } from "../../../../utils/text";
import { isVerticalImg } from "../../../../utils/image";
import { cardName } from "../../../../utils/account-name";
import { translation } from "../../../../utils/translator";
import { CARD_TYPE } from "../../../../constants/CARD_DATA";
import Badge from "../../../../components/Badge";
import defaultCardImage from "../../../../assets/images/bank-card-images/default-card-img.png"
import { isEmpty } from "../../../../utils/lodashExtend";
import { useHistory } from "react-router-dom";
import useForm from "../../../../hooks/useForm";
import { cloneDeep, findIndex, get } from "lodash";
import Icon from "../../../../components/Icon";
import CommentIcon from "../../../../assets/images/icon/comment-icon.svg"
import { HashLink as Link } from "react-router-hash-link"
import PageHeader from "../../../../components/PageHeader";
import { downExcelFile } from "../../../../utils/download";

const PurchaseList = ({ permission, activeTab, tabList }) => {
  const history = useHistory()
  const [sortFields, setSortFields] = useState([
    { key: "useDate", order: 'desc' },
    { key: "trCount", order: '' },
    { key: "useAmt", order: '' },
  ])
  const [fields, setFields] = useState([]);
  const [resultRow, setResultRow] = useState({});
  // 상세 모달
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    setFields([
      { title: "결제일", key: "useDate", sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      {
        title: "신용카드", key: "useCard", onValue: (value, field, data) => {
          const { cardImg, cardCompany, cardNo, accountType } = data.useCard
          return (
            !isEmpty(value) ? (
              <div className="inline-block text-align-left" style={{ width: '400px' }}>
                <div
                  className={classnames("card-img-wrap", {
                    vertical: isVerticalImg(cardImg),
                  })}
                >
                  <img src={cardImg || defaultCardImage} alt={cardCompany} onError={(e) => e.target.src = defaultCardImage} />
                </div>
                <Badge
                  className={classnames("card-type-badge", {
                    vertical: isVerticalImg(cardImg),
                  })}
                  color={accountType === 'card' ? "secondary" : 'warning'}
                  size="sm"
                  label={translation(CARD_TYPE, accountType)}
                />
                <span
                  className="card-name"
                >
                  {`${cardName(cardCompany, cardNo)} ${data.useCard.cardName}`}
                </span>
              </div>) : (<></>)
          );
        },
      },
      { title: "별칭", key: "useCard.nickName" },
      { title: "거래건수", key: "trCount", type: "comma", sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      { title: "결제금액", key: "useAmt", type: "comma", sort: (key) => handleSort(key), order: (key) => orderKey(key) },
      { title: "출금액", key: "acctOutAmt", type: "comma" },
      {
        title: '',
        key: 'comments',
        onValue: (value) => {
          return (
            !isEmpty(value) ? (
              <>
                <Icon src={CommentIcon} />
                <span className="ml-4 font-bold">{value.count}</span>
              </>
            ) : (<></>)
          )
        }
      }
    ])
  }, [sortFields])

  const {
    form,
    setForm,
    setSubmit,
    handleOnChange,
    // LIST 용
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    setOrderBy
  } = useForm(
    {
      order: [
        {
          useDate: "desc",
        },
      ],
      range: {
        useDate: isEmpty(history.location.state) ? [getDay(7), getDay()] : history.location.state.date
      },
      hasAcctOutAmt: false,
      page: 0,
      limit: 10,
      search: {
        cardName: get(history, 'location.state.data.cardName') || "",
      }
    },
  )

  useEffect(() => {
    const sortField = sortFields.find((field) => !isEmpty(field.order))
    if (sortField)
    {
      setOrderBy(sortField)
    }
  }, [sortFields])

  useEffect(() => {
    submit(form);
    setSubmit(submit)
  }, []);

  const submit = (params) => {
    let _params = cloneDeep(params)
    if (_params.hasAcctOutAmt)
    {
      _params = {
        ..._params,
        hasAcctOutAmt: false
      }
    } else delete _params.hasAcctOutAmt
    setIsLoading(true);
    getCardPurchaseSummaries(getParams(_params))
      .then((res) => {
        const { totalCount, cardPurchaseSummaries, comment } = res.data
        const transList = cardPurchaseSummaries.map((invoice) => ({
          ...invoice,
          comments: comment.listByPost.find(c => c.postIdx === invoice.idx) || {}
        }))
        setResultRow({
          useDate: ' ',
          useCard: '',
          trCount: res.data.trCountSum,
          useAmt: res.data.useAmtSum,
          acctOutAmt: res.data.acctOutAmtSum,
        });
        setList(transList);
        setTotal(totalCount);
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const filterConfig = [
    {
      title: "조회기간",
      type: "customDatePicker",
      key: "range.useDate",
    },
    {
      title: "출금 여부",
      type: "checkbox",
      key: "noClientMapped",
      label: "출금액 미입력만 보기",
      checked: form.hasAcctOutAmt,
      onChange: (check) => {
        setForm({
          ...form,
          hasAcctOutAmt: check
        })
      },
    },
    {
      title: "카드명 검색",
      key: "search.cardName",
      placeholder: '카드사 입력'
    },
  ]

  const handleRowClick = (data, e) => {
    const { className } = e.target;
    if (className.includes("expand-btn")) return;
    setOpen(true);
    setFormData(data);
  };

  const handleSort = (key) => {
    const sortField = sortFields.find(field => field.key === key)
    const idx = findIndex(sortFields, sortField)
    let newArray = [...sortFields.map((field) => ({
      ...field,
      order: field.key !== key ? '' : field.order
    }))]
    newArray[idx] = {
      key,
      order: newArray[idx].order !== 'desc' ? 'desc' : 'asc'
    }
    setSortFields(newArray)
  }

  const orderKey = (key) => {
    const sortField = sortFields.find(field => field.key === key)
    return sortField.order
  }

  const headerButtons = [
    {
      color: "gray-line",
      label: (
        <>
          엑셀다운로드 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {
        const from = form.range.useDate[0]
        const to = form.range.useDate[1]

        getCardPurchaseSummariesExcel(getParams(form)).then((res) => {
          downExcelFile(res, `신용카드 매입 내역  ${from}~${to} .xlsx`)
        })
      },
      disabled: isEmpty(list)
    },
  ];

  return (
    <>
      <PageHeader
        title={"신용카드 내역"}
        activeTab={activeTab}
        tabList={tabList}
        buttons={headerButtons}
      />
      <Filters
        isLoading={isLoading}
        filters={filterConfig}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange} />
      <ControlTable
        onSelect={handleRowClick}
        isLoading={isLoading}
        fields={fields}
        sortField={sortFields.find((field) => !isEmpty(field.order))}
        list={list}
        isExpand={true}
        expandCol={7}
        resultRow={resultRow}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        total={total}
        ExpandData={PurchaseSummaries}
        noDataText={
          <Link
            to="/manager/financial?tab=auto-scrapping#section-three"
            className="text-align-center"
            scroll={el => { el.scrollIntoView(true); window.scrollBy(0, 200) }}
          >
            <p className="color-gray-5 nowrap">
              {"조회된 내역이 없습니다. 필터 변경 또는"}
            </p>
            <p className="color-gray-5 nowrap">
              {"관리자 > 금융 정보 자동 수집 > 신용카드 매입 정보를 연동해주세요."}
            </p>
            <p className="color-main-80 font-size-15">
              {"클릭시 해당 메뉴로 이동합니다."}
            </p>
          </Link>
        }
      />
      <Purchase
        open={open}
        setOpen={setOpen}
        data={formData}
        setData={setFormData}
        permission={permission}
        submit={filterSubmit}
      />
    </>
  );
};

export default PurchaseList;
